
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'

export default {
name: 'app',
components: {Tabbar, TabbarItem, XHeader, ViewBox},
data () {
return {
tabbarshow: true,
isLoading: false,
showMenu: false,
menus: [],
logintext: 'off'
}
},
methods: {
status: {
get: function () {
return this.bus.logined ? '线' : '匿'
}
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue